'use strict';

import angular from 'angular';
import membershipComponent from './membership.component';
import cancelMembershipModal from './cancel_membership/cancel_membership_modal';
import cancelMembershipService from './cancel_membership/cancel_membership_service';

export default angular
  .module('membership', [])
  .component('saMembership', membershipComponent)
  .component('saCancelMembershipModal', cancelMembershipModal)
  .factory('cancelMembershipService', cancelMembershipService)
  .name;



// WEBPACK FOOTER //
// ./app/src/modules/membership/index.js